module.exports = __webpack_public_path__ + "static/media/A_lazy_ui.320dad3b.png";